import { useRef } from 'react';
import type { Counter } from './types';
import { counterMB } from './adapter';
import { formatMB } from './format';

/**
 * Running traffic counter for one object: interpolated between samples,
 * never shown smaller than before, restarted when the server value drops
 * (a destination switched off and on is a new output that counts from 0).
 */
export function useCounter(c: Counter | undefined, now: number): string {
  const shown = useRef<{ mb: number; base: number } | null>(null);
  const mb = counterMB(c, now);
  if (mb === undefined || !c) return '—';
  const prev = shown.current;
  const base = c.bytes;
  const v = prev && base >= prev.base ? Math.max(prev.mb, mb) : mb;
  shown.current = { mb: v, base };
  return formatMB(v);
}
